export async function tryCatch<T, TError = any>(fn: Promise<T>): Promise<[TError, T]> {
    try {
        return [null, await fn];
    } catch (error) {
        return [error as TError, null as T]
    }
}

export function tryCatchSync<T, TError = any>(fn: () => T): [TError, T] {
    try {
        return [null, fn()];
    } catch (error) {
        return [error as TError, null as T]
    }
}